import { API } from '~apis/axios/instance';
import { ResponseBase, ResponseBaseWithData } from '~types/response';

type Representative = {
  /** 대표자 id */
  id: string;
  /** 회사 id */
  companyId: string;
  /** 대표자명 */
  name: string;
  /** 휴대폰 번호 */
  phoneNumber: string;
  /** email */
  email: string;
  /** 생년월일 */
  dateOfBirth: string;
  createdAt: string;
  updatedAt: string;

  gender: 'MALE' | 'FEMALE';
};
export interface GetRepresentativeResponse extends ResponseBase {
  data: Representative[];
}

/**
 * 대표자 조회 API
 * @link https://apollo11.dev.clobe.ai/swagger-ui/index.html#/company-controller/getCompanyRepresentatives
 * @param companyId
 * @returns
 */
export function getRepresentativeInfo(companyId: string) {
  return API.get<GetRepresentativeResponse>(`/api/v2/companies/${companyId}/representatives`);
}

export type RepresentativePayload = {
  name: string;
  phoneNumber: string;
  email: string;
  dateOfBirth: string;
  representativeId?: string;
  isEdited?: boolean;
  gender: 'MALE' | 'FEMALE';
};
/**
 * 대표자 수정 API
 * @link https://apollo11.dev.clobe.ai/swagger-ui/index.html#/company-controller/createCompanyRepresentative
 * @param companyId
 * @returns
 */
interface PutRepresentativeInfoRequest {
  companyId: string;
  payload: {
    createList: RepresentativePayload[];
    updateList: RepresentativePayload[];
    deleteList: string[];
  };
}
export function putRepresentativeInfo(request: PutRepresentativeInfoRequest) {
  return API.put<GetRepresentativeResponse>(
    `/api/v2/companies/${request.companyId}/representatives`,
    {
      data: request.payload,
    },
  );
}

/**
 * 대표자 삭제 API
 * @link https://apollo11.dev.clobe.ai/swagger-ui/index.html#/company-controller/createCompanyRepresentative
 * @param companyId
 * @returns
 */
export function deleteRepresentativeInfo(companyId: string, representativeId: string) {
  return API.delete<GetRepresentativeResponse>(
    `/api/v2/companies/${companyId}/representatives/${representativeId}`,
  );
}

/**
 * 대표자 신용조회 check 필요한지 여부 확인 API
 * @link https://apollo11.dev.clobe.ai/swagger-ui/index.html#/company-representative-credit-controller/checkRequired
 * @param companyId
 * @returns
 */
export function checkRequiredRepresentative(companyId: string) {
  return API.get<ResponseBaseWithData<boolean>>(
    `/api/v2/companies/${companyId}/representatives/credits/check-required`,
  );
}
